//@flow
import agentRoutes from './agentRoutes';
import publicRoutes from './publicRoutes';

export const routesConfig = {
  PUBLIC: publicRoutes,
  AGENT: agentRoutes
};
